export default "__VITE_ASSET__FtxAl$uu__"